import { BehaviorSubject } from 'rxjs';

const defaultCriteria = {
  limit: 10,
  orderField: null,
  page: 0,
};

export default class WorkspaceRepository {
  workSpaces$ = new BehaviorSubject([]);
  searchCriteria$ = new BehaviorSubject(defaultCriteria);

  constructor({ workspaceService }) {
    this.workspaceService = workspaceService;
  }

  async createWorkspace(data) {
    return this.workspaceService.createWorkspace(data);
  }

  async getWorkspaces(criteria) {
    const workspaces = await this.workspaceService.getWorkspaces({
      ...this.searchCriteria$.getValue(),
      ...criteria,
    });
    this.workSpaces$.next(workspaces);
  }

  async getWorkspaceById(id) {
    const updatedWorkspace = await this.workspaceService.getWorkspaceById(id);
    return updatedWorkspace;
  }

  resetSearchCriteria() {
    this.searchCriteria$.next(defaultCriteria);
  }

  updateSearchCriteria(criteria) {
    this.searchCriteria$.next({
      ...this.searchCriteria$.getValue(),
      ...criteria,
    });
  }

  updateWorkspace(data, workspaceId) {
    return this.workspaceService.updateWorkspace(data, workspaceId);
  }

  requestClinicCode(name) {
    return this.workspaceService.requestClinicCode(name);
  }

  updateCanRequestBeforePay(id, isAllowed) {
    return this.workspaceService.updateCanRequestBeforePay(id, isAllowed);
  }

  updateCreatorMode(id, isActive) {
    return this.workspaceService.updateCreatorMode(id, isActive);
  }

  updateNamespaces(id, namespaceIds) {
    return this.workspaceService.updateNamespaces(id, namespaceIds);
  }

  updateDiscountId(id, discountId) {
    return this.workspaceService.updateDiscountId(id, discountId);
  }

  discountDetail() {
    return this.workspaceService.discountDetail();
  }

  updateLandingUrl(id, landingUrl) {
    return this.workspaceService.updateLandingUrl(id, landingUrl);
  }

  updateSubdomain(id, subdomain) {
    return this.workspaceService.updateSubdomain(id, subdomain);
  }

  updateWorkspaceMainFileType(id, mainFileType) {
    return this.workspaceService.updateWorkspaceMainFileType(id, mainFileType);
  }

  updateWorkspaceRadiologyReportRequired(id, isRequired) {
    return this.workspaceService.updateWorkspaceRadiologyReportRequired(id, isRequired);
  }

  updateWorkspaceSendPlacedOrdersToAdmins(workspaceId, sendPlacedOrders) {
    return this.workspaceService.updateWorkspaceSendPlacedOrdersToAdmins(workspaceId, sendPlacedOrders);
  }

  updateWorkspaceEmailsForPlacedOrders(workspaceId, emails) {
    return this.workspaceService.updateWorkspaceEmailsForPlacedOrders(workspaceId, emails);
  }
}
